// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"051ef30273873314b053","655":"4f51c22442325feba6e1"}[chunkId] + ".js";
};